import { render } from "./EndScreenView.vue?vue&type=template&id=cd410354&scoped=true"
import script from "./EndScreenView.vue?vue&type=script&lang=js"
export * from "./EndScreenView.vue?vue&type=script&lang=js"

import "./EndScreenView.vue?vue&type=style&index=0&id=cd410354&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd410354"]])

export default __exports__